const object = (value) => {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value;
  try { const parsed = JSON.parse(value); return parsed && typeof parsed === 'object' ? parsed : {}; } catch { return {}; }
};
const firstBoolean = (...values) => values.find((value) => typeof value === 'boolean');

// Advertised API support is separate from connectivity, permission and capture success.
export function nativeScreenshotSupport(device, liveState, node) {
  const appNode = object(object(device?.integration_data || device?.integrationData).appNode);
  const state = liveState?.state || {};
  const external = state.externalApp || {};
  const supported = firstBoolean(external.bridgeCapabilities?.accessibilityScreenshot,
    state.bridgeCapabilities?.accessibilityScreenshot, node?.capabilities?.accessibilityScreenshot,
    device?.bridgeCapabilities?.accessibilityScreenshot, appNode.bridgeCapabilities?.accessibilityScreenshot);
  const accessibility = firstBoolean(external.accessibilityEnabled, state.accessibilityEnabled, appNode.accessibilityEnabled);
  return {
    state: supported === false ? 'unsupported' : accessibility === false ? 'unavailable' : supported === true ? 'supported' : 'unknown',
    reason: supported === false ? 'Native screenshot capture is not supported on this device.'
      : accessibility === false ? 'Accessibility capture is unavailable. Check Suitestream Accessibility on the target device.' : '',
    signature: [supported ?? null, accessibility ?? null],
  };
}

export function nativeScreenshotFailure(error) {
  const code = error?.screenshotError || error?.response?.data?.error || error?.response?.data?.response?.error || error?.message || '';
  if (code === 'take_screenshot_requires_api_30') {
    return { state: 'unsupported', reason: 'Screenshot requires Android 11 or newer on this device.' };
  }
  if (/accessibility/i.test(code)) return { state: 'unavailable', reason: 'Accessibility capture is unavailable. Check Suitestream Accessibility on the target device.' };
  if (error?.response?.status === 504 || /timed? ?out|timeout/i.test(code)) {
    return { state: 'timeout', reason: 'Capture timed out. No automatic retry was sent.' };
  }
  // Protected content, vendor callback failures and blank images do not prove unsupported hardware.
  return { state: 'unavailable', reason: 'Preview unavailable. The device may not support capture, or its content may be protected.' };
}
